import { selector } from 'recoil';

import { currentRouteState } from '@/recoil/atoms/currentRouteState';
import { RoutesType } from '@/shared/types/route.type';

export const currentRouteSelector = selector<RoutesType>({
  key: 'currentRouteSelector',
  get: ({ get }) => get(currentRouteState),
});
